import { GatsbyFunctionRequest, GatsbyFunctionResponse } from "gatsby"
import axios from "axios"
import config from "../../config.js"

export enum GeocodeTypes {
  location = "location",
  address = "address",
}

export default async function handler(req: GatsbyFunctionRequest, res: GatsbyFunctionResponse) {
  if (req.method !== "POST" || !req.body) return res.status(400).json("Invalid request")

  try {
    const { type, address, lng, lat } = req.body

    if (!type) throw new Error("Missing type")
    if (!Object.values(GeocodeTypes).includes(type))
      throw new Error(`Invalid type '${type}', must be either '${GeocodeTypes.location}' or '${GeocodeTypes.address}'`)

    if (type === GeocodeTypes.location) {
      if (!lng) throw new Error("Missing longitude")
      if (!lat) throw new Error("Missing latitude")
    } else if (type === GeocodeTypes.address) {
      if (!address) throw new Error("Missing address")
    }

    const search = type === GeocodeTypes.location ? `${lng},${lat}` : encodeURIComponent(address as string)

    // Set to Melbourne CBD, 3000, to bias geocode results to this location
    const proximityParam = `&proximity=${config.services.mapbox.proximityLocation.lng},${config.services.mapbox.proximityLocation.lat}`

    const location = await axios({
      url: `${config.services.mapbox.endpoint}/${search}.json?access_token=${process.env.FUNCTION_MAPBOX_TOKEN}&limit=1${
        type === GeocodeTypes.address ? proximityParam : ""
      }}`,
      method: "GET",
    })

    const responseData = location.data

    if (responseData?.features?.length === 0) throw new Error("No location found")

    res.status(200).json({ status: "success", body: responseData.features[0] })
  } catch (error) {
    console.error((error as Error).message)
    res.status(500).json({ status: "error", body: (error as Error).message })
  }
}
